import React from 'react';
import { BuyButton } from "../Products/Product/Hero";
import buyButtonStyles from '../Products/Product/hero.module.css'
import classNames from "classnames/bind";

const cn = classNames.bind(buyButtonStyles);

export default ({
  product,
  isExtraProduct,
  extraClasses
}) => {
  const { acf } = product;
  const { btn_fade } = acf;

  const fadeStylePrimary = btn_fade && btn_fade.type === "fade" && (btn_fade.button === "primary" || btn_fade.button === "both") ?
    {backgroundImage: `linear-gradient(to right, ${btn_fade.first}, ${btn_fade.second})`}
  : {};

  const productUrls = {
    'mx-8-2-pro-tmr-wireless': 'https://shop.cherry.de/cherry-xtrfy-mx-8-2-pro-tmr.html',
    'mx-8-2-pro-tmr-wireless-white': 'https://shop.cherry.de/cherry-xtrfy-mx-8-2-pro-tmr.html',
  };

  const defaultUrl = 'https://shop.cherry.de/';
  const cherry = productUrls[product.slug] || defaultUrl;

  return (
    <div className={cn(buyButtonStyles.buttonRow, extraClasses)}>
      <BuyButton style={fadeStylePrimary} url={cherry} isExtraProduct={isExtraProduct}>Buy at Cherry Shop</BuyButton>
    </div>
  );
}
